<template>
	<div>
		<svg :width="iconSize" :height="iconSize" viewBox="0 0 25 21" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12.1875 0.922283C12.3869 0.83515 12.6136 0.83515 12.813 0.922283C16.6868 2.61481 20.3582 4.68382 23.7809 7.08298C24.0286 7.2566 24.1539 7.55761 24.1024 7.85568C24.0509 8.15376 23.832 8.39533 23.5404 8.47581C22.8269 8.67274 22.1196 8.88485 21.4187 9.11088C18.5739 10.0284 15.8354 11.1828 13.2264 12.5509L13.223 12.5527C13.1047 12.6147 12.9867 12.6772 12.8689 12.7401C12.6388 12.8631 12.3626 12.8631 12.1326 12.7401C12.0137 12.6766 11.8945 12.6135 11.7751 12.5509C10.485 11.8744 9.16329 11.2502 7.81268 10.681V10.448C7.81268 10.3111 7.88291 10.1897 7.99157 10.1239C9.5594 9.17407 11.1766 8.29766 12.8384 7.49944C13.2274 7.31262 13.3912 6.84589 13.2044 6.45696C13.0176 6.06802 12.5509 5.90417 12.1619 6.09099C10.4544 6.91118 8.79274 7.81166 7.18195 8.78753C6.70968 9.07364 6.39219 9.54192 6.28776 10.0665C5.39721 9.72398 4.49496 9.4049 3.58174 9.11039C2.88088 8.88437 2.17356 8.67272 1.46013 8.4758C1.16854 8.39531 0.949621 8.15374 0.898141 7.85567C0.846661 7.5576 0.971875 7.25659 1.21957 7.08297C4.64232 4.68381 8.3137 2.6148 12.1875 0.922283Z"
				:fill="color" 
			/>
			<path
				d="M13.6053 14.1183C16.1457 12.7608 18.8149 11.6133 21.5896 10.6986C21.7294 12.1724 21.8187 13.6608 21.8557 15.1621C21.8636 15.4842 21.673 15.7781 21.3757 15.9023C18.4057 17.1422 15.5808 18.6606 12.9335 20.4248C12.6711 20.5996 12.3293 20.5996 12.067 20.4248C9.41964 18.6606 6.59469 17.1422 3.62476 15.9023C3.32743 15.7781 3.13681 15.4842 3.14475 15.1621C3.18173 13.6607 3.27103 12.1722 3.41088 10.6983C4.37026 11.0145 5.31701 11.3586 6.25018 11.7296V13.0529C5.78315 13.3231 5.46893 13.828 5.46893 14.4064C5.46893 14.9223 5.71902 15.3799 6.10458 15.6644C6.01133 16.0609 5.87333 16.4489 5.69057 16.8204C6.16213 17.043 6.62965 17.2727 7.09299 17.5094C7.35689 16.9727 7.54822 16.4094 7.667 15.8342C8.21319 15.5907 8.59393 15.043 8.59393 14.4064C8.59393 13.828 8.27971 13.3231 7.81268 13.0529V12.3813C9.03289 12.9144 10.2281 13.4941 11.3962 14.1183C12.0864 14.487 12.9151 14.487 13.6053 14.1183Z"
				:fill="color" 
			/>
			<path
				d="M4.64833 18.2733C5.08493 17.8367 5.4325 17.345 5.69057 16.8204C6.16213 17.043 6.62965 17.2727 7.09299 17.5094C6.76117 18.1843 6.31439 18.817 5.75319 19.3782C5.44809 19.6833 4.95343 19.6833 4.64833 19.3782C4.34324 19.0731 4.34324 18.5784 4.64833 18.2733Z"
				:fill="color" 
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgGraduate',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped>

</style>